(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccm-fresh"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cc-preview]');
  if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const dialog = trigger.closest('.ccfresh').querySelector('.cc-previewmodal');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  event.preventDefault();
  const original = trigger.querySelector('img');
  const image = new Image();
  image.src = trigger.href;
  image.alt = original.alt;
  dialog.querySelector('.cc-modalbody').replaceChildren(image);
  dialog.querySelector('.cc-modaltitle').textContent = original.alt;
  if (!dialog.dataset.ready) {
    dialog.querySelector('[data-cc-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (e.clientX < bounds.left || e.clientX > bounds.right || e.clientY < bounds.top || e.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { if (dialog.ccOpener?.isConnected) dialog.ccOpener.focus({preventScroll:true}); });
    dialog.dataset.ready = 'true';
  }
  dialog.ccOpener = trigger;
  dialog.showModal();
  dialog.scrollTop = 0;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
